__turbopack_context__.v({
  "articleMeta": "articleCard-module-scss-module__acr9GG__articleMeta",
  "card": "articleCard-module-scss-module__acr9GG__card",
  "cardImage": "articleCard-module-scss-module__acr9GG__cardImage",
  "cardMeta": "articleCard-module-scss-module__acr9GG__cardMeta",
  "cardText": "articleCard-module-scss-module__acr9GG__cardText",
  "cardTitle": "articleCard-module-scss-module__acr9GG__cardTitle",
  "categoryName": "articleCard-module-scss-module__acr9GG__categoryName",
  "divider": "articleCard-module-scss-module__acr9GG__divider",
  "featuredArticle": "articleCard-module-scss-module__acr9GG__featuredArticle",
  "featuredContent": "articleCard-module-scss-module__acr9GG__featuredContent",
  "ratgeberArticleCardOnCategoryPage": "articleCard-module-scss-module__acr9GG__ratgeberArticleCardOnCategoryPage",
  "ratgeberArticleImageContainerOnCategoryPage": "articleCard-module-scss-module__acr9GG__ratgeberArticleImageContainerOnCategoryPage",
  "ratgeberFeaturedArticleImageContainer": "articleCard-module-scss-module__acr9GG__ratgeberFeaturedArticleImageContainer",
  "threeLineEllipse": "articleCard-module-scss-module__acr9GG__threeLineEllipse",
});
